$('.js-link-disabled').on('click', function (e) {
    e.preventDefault();
});